<template>
  <div class="d-flex quioscoRipe" v-if="showModule">
    <div class="col-3 pl-0">
      <div class="portada d-flex align-items-center">
        <a v-if="preview.url" :href="preview.url" target="_blank" rel="noopener">
          <img-lr v-if="!userSelect" :image="preview.cover"></img-lr>
          <img v-if="userSelect" :src="preview.cover.url" :alt="preview.cover.alt" :title="preview.cover.title" />
        </a>
        <div v-if="!preview.url">
          <img-lr v-if="!userSelect" :image="preview.cover"></img-lr>
          <img v-if="userSelect" :src="preview.cover.url" :alt="preview.cover.alt" :title="preview.cover.title" />
        </div>
      </div>
    </div>
    <div class="flex-grow-1 pl-3 flex-column d-flex">
      <h3>PORTADAS</h3>
      <div class="ripe-country">
        <a v-if="preview.url" :href="preview.url" target="_blank" rel="noopener">
          <h2 v-html="preview.title"></h2>
        </a>
        <h2 v-if="!preview.url" v-html="preview.title"></h2>
        <template v-if="preview.ripeCountry">
          <hr />
          <img class="flag" :src="`https://s.lalr.co/wg/images/covid/flags/${preview.ripeCountry.key}.svg`"
            :alt="preview.ripeCountry.value">
        </template>
      </div>
      <p class="mb-auto" v-html="preview.lead"></p>
      <div class="slidePortadas">
        <vue-tiny-slider class="cover-items" :mouse-drag="true" :loop="true" items="7" gutter="10"
          controls-container="#customize-controls">
          <div v-for="(item, index) in covers" :key="index">
            <img-lr :image="item.coverMini" :index="index"></img-lr>
          </div>
        </vue-tiny-slider>
        <div class="customize-tools">
          <ul class="controls" id="customize-controls">
            <li class="prev">
              <i class="icon-arrow-left"></i>
            </li>
            <li class="next">
              <i class="icon-arrow-right"></i>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueTinySlider from "vue-tiny-slider";
import axios from "axios";
import { execute } from "./../../../features/lazy-load";
import ImgLr from "../img-lr/ImgLr.vue";
export default {
  components: {
    VueTinySlider,
    ImgLr,
  },
  props: {
    id: String,
  },
  created: function () {
    const _self = this;
    axios.get("/api/ripe/newsstand/" + this.id).then(function (d) {
      if (d.data && d.data.length > 0) {
        _self.covers = d.data;
        _self.showModule = true;
        setTimeout(function () {
          execute();
          _self.initCoverEvents();
        }, 200);
      }
    });
  },
  methods: {
    selectCover: function (idx, arr) {
      this.itemActive = idx;
      if (!this.userSelect) {
        this.userSelect = true;
      }
      arr.forEach((element) => {
        element.classList.remove("active");
        if (element.dataset.index == idx) {
          element.classList.add("active");
        }
      });
    },
    initCoverEvents: function () {
      const _self = this;
      const slickItems = document.querySelectorAll(".cover-items img");
      slickItems.forEach((el, idx, arr) => {
        el.addEventListener("click", function (evt) {
          _self.selectCover(evt.target.dataset.index, arr);
        });
      });
      this.selectCover(0, slickItems);
    },
  },
  computed: {
    preview: function () {
      return this.covers[this.itemActive];
    },
  },
  data: function () {
    return {
      showModule: false,
      covers: [],
      itemActive: 0,
      userSelect: false,
    };
  },
};
</script>
